import styled from "styled-components";
import { TabItem as TabItemUnstyled } from "@marginly/ui/components/tabs";

export const TabItem = styled(TabItemUnstyled)`
  &.disabled {
    opacity: 0.2;
    pointer-events: none;
  }
`;
